<template>
  <MoleculeEditionProductSatellitesIncludedList tipo="juedroop"/>
</template>

<script>
export default {
  name: 'MoleculeEditionProductSatellitesIncludedJuedroop',

  components: {
    MoleculeEditionProductSatellitesIncludedList: () =>
      import('@/components/molecules/MoleculeEditionProductSatellitesIncludedList')
  }
}
</script>
